import _toConsumableArray from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { UnsupportedValueError } from './helpers/util.js';
export function createActivePage(page) {
  return {
    type: 'active',
    page: page
  };
}
export function createPage(page) {
  return {
    type: 'page',
    page: page
  };
}
export function createNavPrevious(page) {
  return {
    type: '<',
    page: page
  };
}
export function createNavNext(page) {
  return {
    type: '>',
    page: page
  };
}
export function createEllipsis(ellipsisPos) {
  return {
    type: "\u2026".concat(ellipsisPos),
    page: undefined
  };
}
export function isNav(item) {
  return item.type === '<' || item.type === '>';
}
export function isEllipsis(item) {
  return item.type === '…L' || item.type === '…R';
}
export function containsEllipsis(composition) {
  return composition.some(isEllipsis);
}
export function isPageWithNumber(item, page) {
  return item.type === 'page' && item.page === page;
}
export function getLastPage(composition) {
  return Math.max.apply(Math, _toConsumableArray(composition.filter(function (item) {
    return item.type === 'active' || item.type === 'page';
  }).map(function (item) {
    return item.page;
  })));
}
export function compositionMatches(composition, startIndex, pattern) {
  if (startIndex < 0) return;
  return pattern.every(function (matchItem, patternIndex) {
    if (!composition[startIndex + patternIndex]) return false;
    var _composition = composition[startIndex + patternIndex],
      type = _composition.type,
      page = _composition.page;
    if (typeof matchItem === 'number') {
      return type === 'page' && page === matchItem;
    } else if (matchItem === '#') {
      return type === 'page';
    } else if (matchItem === '…') {
      return type === '…L' || type === '…R';
    } else if (matchItem === '*') {
      return type === 'active';
    } else {
      throw new UnsupportedValueError(matchItem);
    }
  });
}
export function compositionMatchesEnd(composition, endIndex, pattern) {
  return compositionMatches(composition, endIndex - pattern.length + 1, pattern);
}